import axiosInstance from "./AxiosInstance";

const CallApi = async ({ endPoint, method = "get", data = null }) => {
  const response = await axiosInstance({
    url: endPoint,
    method,
    data,
  });
  return response?.data;
};

export default CallApi;